export const yesNoOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
]

export const filterOptions = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
]

export const IntegrationCategoryOptions = [
    { label: 'WMS', value: 'wms' },
    { label: 'ERP', value: 'erp' },
    { label: 'E-Commerce', value: 'ecommerce' },
    { label: 'Marketplace', value: 'marketplace' },
    { label: 'Shipping', value: 'shipping' },
    { label: 'Payment', value: 'payment' },
    { label: 'Other', value: 'other' },
]

export const titleOptions = [
    { label: 'Mr.', value: 'Mr' },
    { label: 'Mrs.', value: 'Mrs' },
    { label: 'Ms.', value: 'Ms' },
    { label: 'Miss.', value: 'Miss' },
]

export const transportProviderTypeOptions = [
    { value: 'Aggregator', label: 'Aggregator' },
    { value: 'Service Provider', label: 'Service Provider' },
]

export const phoneCountryCodeOptions = [
    {
        value: '61',
        label: 'Australia +61',
        imgPath: '/images/countries/AU.svg',
    },
    // {
    //     value: '+64',
    //     label: 'New Zealand +64',
    //     imgPath: '/img/countries/NZ.svg',
    // },
]

export const serviceTypeOptions = [
    // { value: 'domestic', label: 'Domestic' },
    // { value: 'international', label: 'International' },
    { value: 'road', label: 'Road Service' },
    { value: 'air', label: 'Air Service' },
]

export const productTypeOptions = [
    { value: 'PALLET', label: 'Pallet' },
    { value: 'CARTON', label: 'Carton' },
]

export const flagOptions = {
    1: 'green',
    2: 'red',
    3: 'yellow',
}

export const invoiceStatusOptions = {
    1: 'Matched',
    2: 'Overcharged',
    3: 'Undercharged',
    4: 'Not Verified',
}

export const lengthOption = [
    {
        id: 10,
        label: 10,
    },
    {
        id: 25,
        label: 25,
    },
    {
        id: 50,
        label: 50,
    },
    {
        id: 100,
        label: 100,
    },
]
